import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from '../../../../../core';


@Component({
    selector: 'app-new-packages',
    templateUrl: './new-packages.component.html',
    styleUrls: ['./new-packages.component.scss']
})

export class NewPackagesComponent implements OnInit {
    constructor(private dialogRef: MatDialogRef<any>, private httpService: HttpService, @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
    }


    closeDialog(e) {
        console.log(e);
        this.dialogRef.close({ package: e.data });
    }

    close() {
        this.dialogRef.close();
    }
}
